import { render, staticRenderFns } from "./OrderPatientInfoShort.vue?vue&type=template&id=ff249262&"
import script from "./OrderPatientInfoShort.vue?vue&type=script&lang=js&"
export * from "./OrderPatientInfoShort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports